import * as CONSTANT from '../Constants/index';
import moment from 'moment'

export function dashboardFillter<T>(formData: {}, model: T, queryType: number) {
  let filter = ""
  if (formData !== null && formData !== undefined) {
    Object.getOwnPropertyNames(model).forEach((val) => {
      Object.entries(formData).forEach((x) => {
        if (Array.isArray(x)) {
          if (x[0] === val) {
            if (queryType === CONSTANT.DashBoardQueryType.FamilyGroupNotAssinged) {
              filter += `${val} eq null`
              //or contains(${val},'')
            }
            else if (queryType === CONSTANT.DashBoardQueryType.ProductUpdatedToday) {
              let rangestart: string = moment.utc(new Date().setHours(0, 0, 0, 0)).format();
              let rangeend: string = moment.utc(new Date().setHours(0, 0, 0, 0)).add(1, 'd').format();
              filter += `(${val} ge ${rangestart} and ${val} lt ${rangeend} and NewLine eq false)` +
                ` or (CreatedDate ge ${rangestart} and CreatedDate lt ${rangeend} and NewLine eq false and Source eq 'DIMENSION_SERVICE')`
            }
            else if (queryType === CONSTANT.DashBoardQueryType.NewLineTrue) {
              filter += `${val} eq ${true} or ${val} eq null`
            }
          }
        }
      })
    })
  }

  if (filter.endsWith("and ")) {
    filter = filter.substring(0, filter.lastIndexOf("and "))
  }

  return filter
}